import React, { FC } from 'react';
import { LayoutBadge, ResponsiveSize } from '../PortfolioProjectCard/Layout';
import { MadeOnFiverr } from '../shared/internal-project';

interface MadeOnFiverrBadgeProps {
  size: ResponsiveSize;
}

export const MadeOnFiverrBadge: FC<MadeOnFiverrBadgeProps> = ({ size }) => (
  <LayoutBadge size={size}>
    <MadeOnFiverr />
  </LayoutBadge>
);
